<ng-container [ngSwitch]="layout">
  <app-home-layout *ngSwitchCase="Layouts.HomeLayout"></app-home-layout>
  <app-fullscreen-layout
    *ngSwitchCase="Layouts.FullscreenLayout"
  ></app-fullscreen-layout>
</ng-container>
